import { useNavigate } from "react-router-dom";
import type { NavigateOptions, To } from "react-router-dom";
import { Button } from "@mui/material";
import type { ButtonProps } from "@mui/material";
import { ArrowBack as BackIcon } from "@mui/icons-material";

export type BackButtonProps = Omit<
  ButtonProps,
  "variant" | "color" | "onClick" | "startIcon"
> & {
  to: To;
  options?: NavigateOptions;
  children?: React.ReactNode;
};

/**
 * 뒤로 가기 공통 버튼 (네비게이트)
 * @param props
 * @returns
 */
export const BackButton = (props: BackButtonProps) => {
  const navigate = useNavigate();
  const { to, options, children, ...others } = props;

  return (
    <Button
      variant="text"
      color="inherit"
      onClick={() => navigate(to, options)}
      startIcon={<BackIcon />}
      {...others}
      sx={{
        textAlign: "left",
        justifyContent: "flex-start",
        pl: 0,
      }}
    >
      {children}
    </Button>
  );
};

export default BackButton;
